import Input from "../FormComponents/Input";
import ClassSelectorLayout from "../ClassSelectorLayout/ClassSelectorLayout";
import CustomCss from "../BuilderComponents/CustomCss";
import BuilderTabs from "../../Layouts/BuilderTabs";
import React from "react";

const EditTableColumnCell = ({ editElementData, setEditElementData }) => {
  const handleChange = (e) => {
    setEditElementData({ ...editElementData, title: e.target.value });
  };
  const handleChangeCss = (e) => {
    setEditElementData({ ...editElementData, [e.target.name]: e.target.value });
  };
  const handleChangeClasses = (newClasses) => {
    setEditElementData({ ...editElementData, classes: newClasses });
  };
  const tabData = [
    {
      label: "Basic",
      content: (
        <div className="p_3">
          <Input label="Enter Title" value={editElementData.title} onChange={handleChange} />
        </div>
      )
    },
    {
      label: "Style",
      content: (
        <>
          <ClassSelectorLayout
            id={editElementData.cell_id}
            defaultSelected={editElementData?.classes || []}
            onChange={handleChangeClasses}
          />
        </>
      )
    },
    {
      label: "Advanced",
      content: (
        <div style={{ overflow: "visible" }} className="form_basic_field_wrapper sidebar-edit-option-outer">
          <CustomCss
            value={{
              custom_css: editElementData.custom_css || "",
              custom_id: editElementData.custom_id || "",
              custom_classname: editElementData.custom_classname || ""
            }}
            onChange={handleChangeCss}
          />
        </div>
      )
    }
  ];
  return <BuilderTabs tabs={tabData} contentClass="tab-content-scroll" />;
};

export default EditTableColumnCell;
